import React from 'react'

import { Control, SubmitHandler } from 'react-hook-form'

import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import { AuthError, useResendVerificationCode } from '@dentalux/security'

import { OTPFields } from 'src/components/inputs/OtpInput/OtpInput'
import LinkButton from 'src/components/LinkButton/LinkButton'
import { OTPForm } from 'src/components/OTPForm/OTPForm'
import { ErrorCodes } from 'src/config/errorCodes'
import useResend from 'src/hooks/useResend'

type Props = {
  onSubmit: SubmitHandler<OTPFields>
  control: Control<OTPFields>
  deviceSavingPossible: boolean
  handleSubmit: (fn: SubmitHandler<OTPFields>) => () => void
  isLoading?: boolean
  isValid?: boolean
  values?: OTPFields
}

const MFAForm = ({ onSubmit, isLoading, handleSubmit, deviceSavingPossible, isValid, values, control }: Props) => {
  const { t } = useTranslation()
  const router = useRouter()

  const { resend } = useResendVerificationCode({
    onSuccess: () => {
      setLimited({ at: new Date().getTime(), manual: true })
    },
    onTokenExpired: () => {
      router.replace('/login')
    },
    onError: (err: AuthError & { limitedAt?: number }) => {
      setError(err.code)

      if (err.code === ErrorCodes.TooManyVerificationCodesSent) {
        setLimited({ at: err.limitedAt || new Date().getTime(), manual: true })
      }
    },
  })

  const { Resend, setLimited, setError } = useResend({
    resend,
    center: true,
    fullWidth: true,
    intervalInMinutes: 3,
    label: t('b2c.mfa_form.resendMessage'),
    Component: LinkButton,
  })

  return (
    <OTPForm
      deviceSavingPossible={deviceSavingPossible}
      values={values}
      isLoading={isLoading}
      isValid={isValid}
      control={control}
      onSubmit={onSubmit}
      Resend={Resend}
      handleSubmit={handleSubmit}
    />
  )
}

export default MFAForm
